import { useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

/**
 * @typedef {Object} ApprovePaymentResponse
 * @property {boolean} success
 * @property {string} admin_remarks
 * @property {any} data
 */

/**
 * Hook to approve a payment
 */
export const useRejectPayment = () => {
  const { fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const rejectPayment = useCallback(
    async (paymentId, payload) => {
      if (!paymentId) throw new Error("Payment ID is required");

      setLoading(true);
      setError(null);

      try {
        const response = await fetchWithAuth(
          `${apiUrl}/school/payments/${paymentId}/reject`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              admin_remarks: payload?.remarks,
              reason: payload?.reason, // agar backend chahta ho
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to reject payment");
        }

        const result = await response.json();

        if (!result.success) {
          throw new Error(result.message || "Failed to reject payment");
        }

        return result;
      } catch (err) {
        console.error("Reject Payment Error:", err);
        setError(err.message || "Something went wrong");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [apiUrl, fetchWithAuth]
  );

  return {
    rejectPayment,
    loading,
    error,
  };
};
